import {createActionTypes} from "../../../redux/utils/reduxUtils";

enum AuthActions{
    CLEAR_STATE,
    START_AUTHENTICATION,
    CAPTCHA_REQUIRED,
    CLEAR_CAPTCHA_SUCCESS,
    AUTHENTICATE_SUCCESS,
    SET_USER_PROFILE,
    CLEAR_AUTHENTICATION,
    AUTHENTICATE_STEP,
    SET_AUTH_DETAILS,
    SET_AUTH_SUCCESS
}

const actionTypes = createActionTypes(AuthActions, "AUTHENTICATE");

export default actionTypes;
